export const radioStyles = {
	components: {
		Radio: {
			baseStyle: {
				borderRadius: "8px",
				bg: "white",
				padding: "20px",
				border: "1px solid #E4E4E7",
				_before: {
					display: "none",
				},
				transition: ".25s all ease",
				boxSizing: "border-box",
				_focus: {
					border: "1px solid #09090B",
					boxShadow: "none",
				},
				_active: {
					border: "1px solid #09090B",
					boxShadow: "none",
				},
			},
			variants: {
				primary: (props) => ({
					borderRadius: "8px",
					bg: "white",
					padding: "20px",
					border: "1px solid #E4E4E7",
					_before: {
						display: "none",
					},
					transition: ".25s all ease",
					boxSizing: "border-box",
					_focus: {
						border: "1px solid #09090B",
						boxShadow: "none",
					},
					_active: {
						border: "1px solid #09090B",
						boxShadow: "none",
					},
				}),
			},
		},
	},
};
